import { createTheme } from "@mui/material/styles";

// Design tokens ported 1:1 from the old design_guidelines.json / index.css
// custom-properties so the MUI rebuild matches the existing brand exactly.
export const GOLD = "#C5A059";
export const GOLD_BRIGHT = "#D4AF37";

const LIGHT = {
  background: "#FFFFFF",
  surface: "#FAFAFA",
  text: "#0A0A0A",
  border: "rgba(0,0,0,0.08)",
};
const DARK = {
  background: "#050505",
  surface: "#121212",
  text: "#FFFFFF",
  border: "rgba(255,255,255,0.1)",
};

// Airbnb-style shadow-first depth: soft two-layer shadow instead of a hard border.
export function cardShadow(mode) {
  return mode === "dark"
    ? "0 1px 2px rgba(0,0,0,0.4), 0 4px 16px rgba(0,0,0,0.35)"
    : "0 1px 2px rgba(0,0,0,0.08), 0 4px 12px rgba(0,0,0,0.06)";
}

export function buildTheme(mode) {
  const tokens = mode === "dark" ? DARK : LIGHT;
  const accent = mode === "dark" ? GOLD_BRIGHT : GOLD;
  const shadow = cardShadow(mode);

  return createTheme({
    palette: {
      mode,
      primary: { main: accent, contrastText: mode === "dark" ? "#050505" : "#fff" },
      background: { default: tokens.background, paper: tokens.surface },
      text: { primary: tokens.text },
      divider: tokens.border,
    },
    shape: { borderRadius: 10 },
    typography: {
      fontFamily: "'Outfit', system-ui, sans-serif",
      h1: { fontFamily: "'Playfair Display', serif", letterSpacing: "-0.01em" },
      h2: { fontFamily: "'Playfair Display', serif", letterSpacing: "-0.01em" },
      h3: { fontFamily: "'Playfair Display', serif", letterSpacing: "-0.01em" },
      h4: { fontFamily: "'Playfair Display', serif", letterSpacing: "-0.01em" },
      h5: { fontFamily: "'Playfair Display', serif", letterSpacing: "-0.01em" },
      h6: { fontFamily: "'Playfair Display', serif", letterSpacing: "-0.01em" },
      button: { textTransform: "none", fontWeight: 500 },
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: { borderRadius: 9999, letterSpacing: "0.02em" },
          containedPrimary: {
            boxShadow: "none",
            transition: "transform 0.25s ease, box-shadow 0.25s ease, background 0.25s ease",
            "&:hover": {
              boxShadow:
                mode === "dark"
                  ? "0 12px 30px -10px rgba(212,175,55,0.7)"
                  : "0 12px 30px -10px rgba(197,160,89,0.6)",
            },
          },
          outlined: { borderColor: tokens.border },
        },
      },
      MuiCard: {
        styleOverrides: {
          root: { borderRadius: 14, border: "none", boxShadow: shadow },
        },
      },
      MuiPaper: {
        styleOverrides: { root: { backgroundImage: "none" } },
      },
      MuiChip: {
        styleOverrides: {
          root: { borderRadius: 8, fontWeight: 500 },
        },
      },
      MuiOutlinedInput: {
        styleOverrides: {
          root: { borderRadius: 10 },
        },
      },
      MuiTextField: {
        defaultProps: { size: "small" },
      },
    },
  });
}

export default buildTheme;
